import React from 'react';
import { useParams } from 'react-router-dom';
import { Sections } from './Sections';

export const Route = () => {
  const { tab } = useParams();

  return <Sections activeTab={tab as any} />;
};
